export default __webpack_public_path__ + "static/media/gamepad.c9269ef5.svg";